import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";

const STEPS = [
  { num: "01", title: "Design", copy: "Develop a home concept around your lifestyle, preferences and block." },
  { num: "02", title: "Architecture", copy: "Work with the in-house architect to develop the design and architectural direction." },
  { num: "03", title: "Drafting", copy: "Create detailed drawings and plans required to move the project forward." },
  { num: "04", title: "Permissions & Approvals", copy: "Assist with the relevant permission and approval process." },
  { num: "05", title: "Construction", copy: "Custom builders bring the approved design to life." },
  { num: "06", title: "Handover", copy: "Complete the final stages and hand over your new home." },
];

export default function Services() {
  return (
    <section id="services" className="bg-sand py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <p className="eyebrow text-arc mb-6">Our Services</p>
            </Reveal>
            <MaskedLines
              className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl"
              lines={[<>From First Idea</>, <>to <span className="italic text-gradient">Final Handover.</span></>]}
            />
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-mist leading-relaxed">
              One team across the whole journey — design, architecture, drafting, approvals,
              construction and handover.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={(i % 3) * 0.08} className="bg-sand">
              <div
                className="group h-full bg-cream p-8 lg:p-10 hover:bg-ink transition-colors duration-500"
                data-testid={`service-card-${s.num}`}
              >
                <span className="font-mono text-sm text-arc group-hover:text-sky transition-colors duration-500">
                  {s.num}
                </span>
                <h3 className="font-serif text-2xl font-medium text-charcoal group-hover:text-cream mt-5 transition-colors duration-500">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-mist group-hover:text-cream/70 transition-colors duration-500">
                  {s.copy}
                </p>
                <span className="block h-[3px] w-10 bg-gradient-brand mt-7 group-hover:w-full transition-all duration-700" />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-12 text-center">
          <a
            href="#process"
            data-testid="services-cta-explore-process"
            className="group inline-flex items-center gap-3 font-semibold text-charcoal border-b-2 border-arc pb-1 hover:text-arc transition-colors duration-300"
          >
            Explore Our Process
            <ArrowRight size={17} className="group-hover:translate-x-1.5 transition-transform duration-300" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
